module.exports = __webpack_public_path__ + "img/棕黄色logo.b6e9cb61.png";